import React from "react";
import styled from "styled-components";

const Donations = () => {
  return (
    <Wrapper>
      <h1>05 - Dame oro</h1>
      <p>
        Si quieres ayudarnos a financiar el proyecto, puedes hacerlo a través de
        nuestro Paypal:{" "}
        <span style={{ color: "var(--clr-light-blue)" }}>
          ligaespaoe@gmail.com
        </span>
      </p>
      <p>
        Todas las donaciones serán destinadas integramente a premios para el
        torneo.
      </p>
      <p>
        A la hora de realizar la donación es importante marcar la opción "Amigos
        y Familiares".
      </p>
      <img
        src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/paypal_tutorial.jpg"
        alt="Paypal tutorial"
      />
      <p>Muchas gracias a todos por vuestra ayuda</p>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
`;
export default Donations;
